import { useEffect, useState } from "react"

export function useLocalStorage<T>(key: string, initialValue: T): [T, (value: T) => void] {
  const [stored, setStored] = useState<T>(() => {
    const item = localStorage.getItem(key)
    if (item === null) return initialValue
    if (typeof initialValue === "boolean") return (item === "true") as unknown as T
    return (item as unknown as T)
  })

  useEffect(() => {
    localStorage.setItem(key, String(stored))
  }, [key, stored])

  return [stored, setStored]
}
